// The single source of truth for which languages the interface offers.
// i18next's config and every language control read from here.
export const SUPPORTED_LANGUAGES = ['en', 'lt'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
